import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import {
  MessageBankDialog,
  MessageBankEmpty,
  MessageBankReplies,
} from '@/features/messaging/message-bank/MessageBankDialog'
import { ContentLoading } from '@/components/ContentLoading'
import { type MessageBankDialogViewModel } from './MessageBankDialogViewModel'

export interface MessageBankDialogContainerProps {
  vm: MessageBankDialogViewModel
}

export const MessageBankDialogContainer = observer(
  function MessageBankDialogContainer({ vm }: MessageBankDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <MessageBankDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        isLoading={vm.fetch.pending}
        hasReplies={vm.messageBankHasReplies}
        onUseSelectedReply={vm.useSelectedReply}
      >
        {vm.fetch.match({
          pending: () => <ContentLoading size="compact" />,
          rejected: () => (
            <MessageBankEmpty corporateMode={shellInfo.corporateMode} />
          ),
          resolved: () =>
            vm.messageBankHasReplies ? (
              <MessageBankReplies
                replies={vm.replyItems}
                selectedReply={vm.selectedReplyItem}
                onSelectReply={vm.selectReply}
              />
            ) : (
              <MessageBankEmpty corporateMode={shellInfo.corporateMode} />
            ),
        })}
      </MessageBankDialog>
    )
  },
)
